// @flow
import styled, { css } from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import Icon from "@fdr/static-ui/Icons/";
import { fontBold, fontNormal } from "@fdr/static-ui/Typography";

const getFontSize = (isSmall, isHeaderSelector) => {
  if (isHeaderSelector) {
    return "14px";
  }
  if (isSmall) {
    return "16px";
  }
  return "20px";
};

export const IconWrapper = styled(Icon)`
  display: flex;
  flex: 0 0 16px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: flex-start;
  flex: 1 1 auto;
  text-align: left;
`;

export const TrackNameContainer = styled.span`
  font-size: ${({ isSmall, isHeaderSelector }) =>
    getFontSize(isSmall, isHeaderSelector)};
  color: ${buildColor("white", "100")};
  font-family: ${(props) => (props.isSmall ? fontNormal : fontBold)};
  padding: 3px 6px 0 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
  height: 17px;
`;

export const HighlightedContainer = styled.span`
  font-size: 20px;
  color: ${buildColor("white", "100")};
  font-family: ${fontBold};
  font-weight: 500;
  padding-right: 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const RaceNumberContainer = styled.span`
  font-size: ${({ isSmall, isHeaderSelector }) =>
    getFontSize(isSmall, isHeaderSelector)};
  color: ${buildColor("white", "100")};
  font-family: ${(props) => (props.isSmall ? fontNormal : fontBold)};
  padding-right: 2px;
  flex: 0;
`;

export const Container = styled.div`
  display: flex;
  ${({ isHeaderSelector }) =>
    isHeaderSelector &&
    css`
      margin-top: 2px;
    `};
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  flex: 1 1 auto;
  min-width: 50px;
  width: 100%;

  & > a {
    width: 100%;
  }
`;
